import { FormControlLabel as MuiFormControlLabel } from '@material-ui/core';
import styled, { css } from 'styled-components';
import { generateColSpan } from '../utils';
import { ColSpan } from '../types';

export const FormControlLabel = styled(MuiFormControlLabel)<{
  $colspan?: ColSpan;
  $fitContent?: boolean;
}>`
  width: ${({ $fitContent }) => ($fitContent ? 'fit-content' : '100%')};
  .MuiFormControlLabel-label {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  ${({ $colspan, theme }) => css`
    ${$colspan ? generateColSpan($colspan) : ''};

    text-overflow: ellipsis;
    color: ${theme.splitcPalette.neutral[1]};

    .MuiCheckbox-root {
      &.Mui-disabled {
        color: ${theme.splitcPalette.neutral[7]};
      }
    }
  `}
`;
